import {
  FETCH_EXCLUSION_FILES,
  FETCH_EXCLUSION_FILES_SUCCESS,
  FETCH_EXCLUSION_FILES_FAILURE,
  FETCH_EXCLUSION_FILE,
  FETCH_EXCLUSION_FILE_SUCCESS,
  FETCH_EXCLUSION_FILE_FAILURE,
  ADD_EXCLUSION_FILE,
  ADD_EXCLUSION_FILE_SUCCESS,
  ADD_EXCLUSION_FILE_FAILURE,
  UPDATE_EXCLUSION_FILE,
  UPDATE_EXCLUSION_FILE_SUCCESS,
  UPDATE_EXCLUSION_FILE_FAILURE,
  REMOVE_EXCLUSION_FILE,
  REMOVE_EXCLUSION_FILE_SUCCESS,
  REMOVE_EXCLUSION_FILE_FAILURE,
} from './types'

export const fetchExclusionFiles = (accessToken) => ({
  type: FETCH_EXCLUSION_FILES,
  payload: { accessToken },
})

export const fetchExclusionFilesSuccess = (data) => ({
  type: FETCH_EXCLUSION_FILES_SUCCESS,
  payload: data,
})

export const fetchExclusionFilesFailure = (error) => ({
  type: FETCH_EXCLUSION_FILES_FAILURE,
  payload: error,
})

export const fetchExclusionFile = (fileName, accessToken) => ({
  type: FETCH_EXCLUSION_FILE,
  payload: { fileName, accessToken },
})

export const fetchExclusionFileSuccess = (fileName, content) => ({
  type: FETCH_EXCLUSION_FILE_SUCCESS,
  payload: { fileName, content },
})

export const fetchExclusionFileFailure = (fileName, error) => ({
  type: FETCH_EXCLUSION_FILE_FAILURE,
  payload: { fileName, error },
})

export const addExclusionFile = (fileName, content, accessToken) => ({
  type: ADD_EXCLUSION_FILE,
  payload: { fileName, content, accessToken },
})

export const addExclusionFileSuccess = (fileName) => ({
  type: ADD_EXCLUSION_FILE_SUCCESS,
  payload: fileName,
})

export const addExclusionFileFailure = (fileName, error) => ({
  type: ADD_EXCLUSION_FILE_FAILURE,
  payload: { fileName, error },
})

export const updateExclusionFile = (fileName, content, accessToken) => ({
  type: UPDATE_EXCLUSION_FILE,
  payload: { fileName, content, accessToken },
})

export const updateExclusionFileSuccess = (fileName) => ({
  type: UPDATE_EXCLUSION_FILE_SUCCESS,
  payload: fileName,
})

export const updateExclusionFileFailure = (fileName, error) => ({
  type: UPDATE_EXCLUSION_FILE_FAILURE,
  payload: { fileName, error },
})

export const removeExclusionFile = (fileName, accessToken) => ({
  type: REMOVE_EXCLUSION_FILE,
  payload: { fileName, accessToken },
})

export const removeExclusionFileSuccess = (fileName) => ({
  type: REMOVE_EXCLUSION_FILE_SUCCESS,
  payload: fileName,
})

export const removeExclusionFileFailure = (fileName, error) => ({
  type: REMOVE_EXCLUSION_FILE_FAILURE,
  payload: { fileName, error },
})
